import { Plugins } from "@capacitor/core";

const { Device } = Plugins;

export function isNativeIosPlatform() {
  return (
    typeof window !== "undefined" &&
    window.Capacitor != null &&
    typeof window.Capacitor.getPlatform === "function" &&
    window.Capacitor.getPlatform() === "ios"
  );
}

export async function getDeviceInfo() {
  const info = await Device.getInfo();
  return info;
}

export async function isIosDevice() {
  const info = await Device.getInfo();
  return info["platform"] === "ios";
}

export async function isWebDevice() {
  const info = await Device.getInfo();
  return (
    info["platform"] === "web" &&
    info["operatingSystem"] !== "ios" &&
    info["operatingSystem"] !== "android"
  );
}
